
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit: function (e, page) {
      var app = this.$app;
      var $$ = this.$;
      var ctx = page.route.context || {};
      var listEndpoint = ctx.listEndpoint || '';
      var perPage = ctx.perPage || 10;
      var currentPage = ctx.currentPage || 1;
      var hasMore = !!ctx.hasMore;
      var loadingMore = false;
      if (!listEndpoint || !hasMore)
        return;
      function esc(s) {
        if (s === null || s === undefined)
          return '';
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      function renderDoctorCard(d) {
        var dp = d.dp_url ? d.dp_url : 'static/img/default_doctor.svg';
        var partnerClass = d.isPartnerDoctor == 1 ? ' is-partner' : '';
        var verifiedChip = d.isPartnerDoctor == 1 ? '<a href="#" class="doctor-verified-chip partner-info-btn">' + '<i class="icon f7-icons if-not-md doctor-verified-chip-seal">checkmark_seal_fill</i>' + '<i class="icon material-icons md-only doctor-verified-chip-seal">verified</i>' + '<span class="doctor-verified-chip-text">mDOC Verified</span>' + '</a>' : '';
        var degree = d.degree ? '<div class="doctor-card-degree">' + esc(d.degree) + '</div>' : '';
        var deptChip = d.dep_name ? '<span class="doctor-card-chip doctor-card-chip-dept">' + esc(d.dep_name) + '</span>' : '';
        var expChip = d.experiance ? '<span class="doctor-card-chip doctor-card-chip-exp">' + esc(d.experiance) + '+ yr exp</span>' : '';
        var addr = d.address ? '<div class="doctor-card-hospital-address">' + esc(d.address) + '</div>' : '';
        var directions = d.lat ? '<a class="doctor-card-direction link external" href="https://www.google.com/maps/place/' + esc(d.lat) + '+' + esc(d.log) + '" target="_system"><i class="icon material-icons">directions</i></a>' : '';
        var hospitalBlock = d.hospital_name ? '<div class="doctor-card-hospital">' + '<div class="doctor-card-hospital-info">' + '<i class="icon f7-icons if-not-md">house_fill</i>' + '<i class="icon material-icons md-only">local_hospital</i>' + '<div>' + '<div class="doctor-card-hospital-name">' + esc(d.hospital_name) + '</div>' + addr + '</div>' + '</div>' + directions + '</div>' : '';
        var bookBtn = d.preLive == 0 ? '<button type="button" class="doctor-card-book doctor-card-book-disabled" disabled>Currently unavailable</button>' : '<a href="/booking/' + esc(d.id) + '/Normal/" class="doctor-card-book link">Book appointment</a>';
        return '<div class="doctor-card' + partnerClass + '">' + '<div class="doctor-card-top">' + '<div class="doctor-card-photo"><img src="' + esc(dp) + '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'"></div>' + '<div class="doctor-card-info">' + '<div class="doctor-card-name">Dr. <span class="doctorNameSearch">' + esc(d.name) + '</span></div>' + verifiedChip + degree + '<div class="doctor-card-meta">' + deptChip + expChip + '</div>' + '</div>' + '<div class="doctor-card-fee"><div class="doctor-card-fee-label">Fee</div><div class="doctor-card-fee-amount">\u20B9' + esc(d.fee) + '</div></div>' + '</div>' + hospitalBlock + '<div class="doctor-card-actions">' + bookBtn + '</div>' + '</div>';
      }
      function loadNextPage() {
        if (loadingMore || !hasMore)
          return;
        loadingMore = true;
        $$('#hospitalDoctorListPreloader').show();
        var nextPage = currentPage + 1;
        var url = app.data.remoteUrl + listEndpoint + '&page=' + nextPage + '&per_page=' + perPage;
        app.request({
          url: url,
          method: 'GET',
          dataType: 'json',
          success: function (response) {
            $$('#hospitalDoctorListPreloader').hide();
            loadingMore = false;
            var list = response && response.data ? response.data : [];
            var meta = response && response.meta ? response.meta : {};
            if (list.length) {
              var html = '';
              list.forEach(function (d) {
                html += renderDoctorCard(d);
              });
              $$('#hospitalDoctorListGrid').append(html);
              currentPage = nextPage;
              hasMore = !!meta.has_more;
              if (!hasMore)
                app.infiniteScroll.destroy('#hospitalDoctorsPage');
            } else {
              hasMore = false;
              app.infiniteScroll.destroy('#hospitalDoctorsPage');
            }
          },
          error: function () {
            $$('#hospitalDoctorListPreloader').hide();
            loadingMore = false;
          }
        });
      }
      $$('#hospitalDoctorsPage').on('infinite', loadNextPage);
    }
  },
  id: 'be33e7467f',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page doctor-list-page" data-name="DoctorList" id="DoctorListPage">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title">';
      r += c(ctx_1.$route.params.hospital_name, ctx_1);
      r += '</div>\n            </div>\n        </div>\n\n        <div class="page-content infinite-scroll-content" id="hospitalDoctorsPage" data-infinite-distance="80">\n            <div class="doctor-list-search-wrap">\n                <form data-search-container="#hospitalDoctorListGrid" data-search-in=".doctor-card-name,.doctor-card-meta,.doctor-card-hospital" class="searchbar searchbar-inline searchbar-init">\n                    <div class="searchbar-inner">\n                        <div class="searchbar-input-wrap">\n                            <i class="icon f7-icons if-not-md mdoc-sb-icon">search</i>\n                            <i class="icon material-icons md-only mdoc-sb-icon">search</i>\n                            <input type="search" placeholder="Search doctors\u2026">\n                            <span class="input-clear-button"></span>\n                        </div>\n                    </div>\n                </form>\n            </div>\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data && this.data.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="doctor-list-count">';
          r += c(ctx_2.total, ctx_2);
          r += ' doctor';
          r += Template7Helpers.js_if.call(ctx_2, 'this.total > 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 's';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' found</div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <div class="doctor-list searchbar-found" id="hospitalDoctorListGrid">\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="doctor-card';
          r += Template7Helpers.js_if.call(ctx_2, 'this.isPartnerDoctor == 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' is-partner';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '">\n                    <div class="doctor-card-top">\n                        <div class="doctor-card-photo">\n                            <img src="';
          r += c(ctx_2.dp_url, ctx_2);
          r += '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'">\n                        </div>\n                        <div class="doctor-card-info">\n                            <div class="doctor-card-name">Dr. <span class="doctorNameSearch">';
          r += c(ctx_2.name, ctx_2);
          r += '</span></div>\n                            ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.isPartnerDoctor == 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <a href="#" class="doctor-verified-chip partner-info-btn" aria-label="mDOC Verified Partner \u2014 tap to learn more">\n                                <i class="icon f7-icons if-not-md doctor-verified-chip-seal">checkmark_seal_fill</i>\n                                <i class="icon material-icons md-only doctor-verified-chip-seal">verified</i>\n                                <span class="doctor-verified-chip-text">mDOC Verified</span>\n                            </a>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.degree', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="doctor-card-degree">';
              r += c(ctx_3.degree, ctx_3);
              r += '</div>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            <div class="doctor-card-meta">\n                                ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.dep_name', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                <span class="doctor-card-chip doctor-card-chip-dept">';
              r += c(ctx_3.dep_name, ctx_3);
              r += '</span>\n                                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.experiance', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                <span class="doctor-card-chip doctor-card-chip-exp">';
              r += c(ctx_3.experiance, ctx_3);
              r += '+ yr exp</span>\n                                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            </div>\n                        </div>\n                        <div class="doctor-card-fee">\n                            <div class="doctor-card-fee-label">Fee</div>\n                            <div class="doctor-card-fee-amount">\u20B9';
          r += c(ctx_2.fee, ctx_2);
          r += '</div>\n                        </div>\n                    </div>\n\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.hospital_name', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="doctor-card-hospital">\n                        <div class="doctor-card-hospital-info">\n                            <i class="icon f7-icons if-not-md">house_fill</i>\n                            <i class="icon material-icons md-only">local_hospital</i>\n                            <div>\n                                <div class="doctor-card-hospital-name">';
              r += c(ctx_3.hospital_name, ctx_3);
              r += '</div>\n                                ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.address', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                <div class="doctor-card-hospital-address">';
                  r += c(ctx_4.address, ctx_4);
                  r += '</div>\n                                ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                            </div>\n                        </div>\n                        ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.lat', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <a class="doctor-card-direction link external" href="https://www.google.com/maps/place/';
                  r += c(ctx_4.lat, ctx_4);
                  r += '+';
                  r += c(ctx_4.log, ctx_4);
                  r += '" target="_system" aria-label="Get directions">\n                            <i class="icon material-icons">directions</i>\n                        </a>\n                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                    </div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                    <div class="doctor-card-actions">\n                        ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.preLive == 0', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <button type="button" class="doctor-card-book doctor-card-book-disabled" disabled>Currently unavailable</button>\n                        ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <a href="/booking/';
              r += c(ctx_3.id, ctx_3);
              r += '/Normal/" class="doctor-card-book link">Book appointment</a>\n                        ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    </div>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n\n            <!-- Infinite scroll preloader -->\n            <div class="preloader infinite-scroll-preloader" id="hospitalDoctorListPreloader" style="display: none;">\n                <span class="preloader-inner">\n                    <span class="preloader-inner-gap"></span>\n                    <span class="preloader-inner-left"><span class="preloader-inner-half-circle"></span></span>\n                    <span class="preloader-inner-right"><span class="preloader-inner-half-circle"></span></span>\n                </span>\n            </div>\n\n            ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <img src="static/img/no_doctor.svg" alt="">\n                <div class="empty-state-title">No doctors at this hospital yet</div>\n                <div class="empty-state-sub">We\'re onboarding doctors regularly \u2014 please check back later.</div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <div class="empty-state searchbar-not-found">\n                <img src="static/img/no_doctor.svg" alt="">\n                <div class="empty-state-title">No doctor matches your search</div>\n                <div class="empty-state-sub">Try a different name or check spelling.</div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    